import React, { useState } from "react";
import "./CreatePiece.css";
import { Button, FormControl, TextField, useMediaQuery } from "@mui/material";
import { makeStyles } from "@mui/styles";
import { useDispatch, useSelector } from "react-redux";
import Locale from "../../locales";
import { createPiece } from "../../redux/actions";
import {
  PIECE_DESCRIPTION,
  PIECE_TITLE,
} from "../../constants/textFieldMaxLengths";
import { teacherRequestFail } from "../../redux/actions/teacher";
import { sanitizeInput } from "../../utils/sanitize";

const useStyles = makeStyles({
  title: {
    width: "100%",
  },
  description: {
    width: "100%",
  },
  mobileselectStudentContainer: {
    width: "100%",
  },
  mobileTitle: {
    width: "100%",
  },
});

const CreatePiece = () => {
  const styles = useStyles();
  const loading = useSelector((state) => state.teacherReducer.loading);
  const currentStudent = useSelector(
    (state) => state.teacherReducer.currentStudent,
  );
  const [title, setTitle] = useState("");
  const [description, setDescription] = useState("");
  const dispatch = useDispatch();
  const isSmall = useMediaQuery("(max-width:1400px)");

  const handleDescriptionChange = (event) => {
    setDescription(event.target.value);
  };

  const handleTitleChange = (event) => {
    setTitle(event.target.value);
  };

  const handleFormSubmit = (event) => {
    event.preventDefault();
    const formData = {
      pieceTitle: sanitizeInput(title),
      studentId: currentStudent,
      pieceDescription: sanitizeInput(description),
    };

    if (!formData.pieceTitle) {
      dispatch(teacherRequestFail(Locale.t("title_is_required")));
      return;
    }
    if (!formData.pieceDescription) {
      dispatch(teacherRequestFail(Locale.t("description_is_required")));
      return;
    }

    if (formData.pieceTitle.length > PIECE_TITLE) {
      dispatch(
        teacherRequestFail(
          Locale.t("piece_title_should_be_less").replace(
            "{{pieceTitle}}",
            PIECE_TITLE,
          ),
        ),
      );
      return;
    }
    if (formData.pieceDescription.length > PIECE_DESCRIPTION) {
      dispatch(
        teacherRequestFail(
          Locale.t("piece_description_should_be_less").replace(
            "{{pieceDescription}}",
            PIECE_DESCRIPTION,
          ),
        ),
      );
      return;
    }
    setTitle("");
    setDescription("");
    dispatch(createPiece(formData));
  };

  return (
    <div className="create-piece-container">
      <div>
        <h1 className="create-piece-headingText">
          {Locale.t("create_a_new_piece")}
        </h1>
      </div>
      <form onSubmit={handleFormSubmit} className="piece-form">
        <div className="piece-form-content-container">
          <FormControl className={isSmall ? styles.mobileTitle : styles.title}>
            <TextField
              value={title}
              multiline
              rows="2"
              helperText={`${title.length}/${PIECE_TITLE}`}
              error={title.length > PIECE_TITLE}
              onChange={handleTitleChange}
              label={Locale.t("piece_title")}
            />
          </FormControl>
        </div>
        <div className="piece-form-content-container">
          <div className={styles.description}>
            <div className="task-description-container">
              <TextField
                fullWidth
                value={description}
                onChange={handleDescriptionChange}
                helperText={`${description.length}/${PIECE_DESCRIPTION}`}
                multiline
                error={description.length > PIECE_DESCRIPTION}
                rows="5"
                label={Locale.t("piece_description")}
              />
            </div>
          </div>
        </div>
        <div className="piece-submit-button-container">
          <Button
            style={{ margin: "auto" }}
            type="submit"
            disabled={loading}
            size="large"
            variant="contained">
            {Locale.t("add_piece")}
          </Button>
        </div>
      </form>
    </div>
  );
};

export default CreatePiece;
